import React from 'react'
import BaseIcon from 'react-icon-base'
import { EColors } from 'app/constants/colors'

const Facebook = props => (
  <BaseIcon width="9" height="16" viewBox="0 0 9 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill={EColors.GREY} fillRule="evenodd">
      <path
        d="M5.425 15.386v-7.02h2.327l.392-2.77H5.425v-1.89c0-.586.48-1.065 1.065-1.065H8.25V.09L6.039.001C3.976-.082 2.576 1.474 2.576 3.307v2.288H.249v2.772h2.327v7.019"
        fill={EColors.GREY}
        fillRule="evenodd"
      />
    </g>
  </BaseIcon>
)

export default Facebook
